import { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../../../../store/hooks';
import { SnackBarContext } from '../../../../../shared/components/snack-bar-context/SnackBarContext';
import { SnackBarContextModel } from '../../../../../shared/components/snack-bar-context/models/snack-bar-context.model';
import { resetFirmwareFilesState } from '../../../../store/slices/firmware.slice';
import { populateUpdateFirmwareFields } from '../../../../utils/populate-update-firmware-fields/populate-update-firmware-fields.util';
import { FirmwareDetailsFormModel } from '../../../FirmwareDetailsForm/models/firmware-form.model';

export const usePopulateEditFirmwareForm = (
  firmwareId: string | undefined,
  isOnEdit: boolean,
  setFormFields: Dispatch<SetStateAction<FirmwareDetailsFormModel>>
) => {
  const navigate = useNavigate();
  const snackBarContext = useContext(SnackBarContext) as SnackBarContextModel;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (firmwareId && isOnEdit) {
      populateUpdateFirmwareFields(
        +firmwareId,
        dispatch,
        setFormFields,
        navigate,
        snackBarContext
      ).then();
    }

    return () => {
      dispatch(resetFirmwareFilesState());
    };
  }, []);
};
